import React, { useEffect, useMemo, useState } from 'react'
import { CustomModalStyled, EduButton, notification } from '@edulastic/common'
import { connect } from 'react-redux'
import Styled from 'styled-components'
import {
  emailRegex,
  isPearOrEdulasticText,
} from '../../../common/utils/helpers'
import ProductsList from '../../src/components/common/PurchaseModals/ProductsList'
import { ModalBody } from '../../src/components/common/PurchaseModals/SubscriptionAddonModal/styled'
import {
  getShowDiscountOfferSelector,
  getSubscriptionSelector,
  slice as subscriptionSlice,
} from '../ducks'
import AuthorCompleteSignupButton from '../../../common/components/AuthorCompleteSignupButton'
import BookkeeperInfoIconWrapper from '../../src/components/common/PurchaseModals/BookkeeperInfoIconWrapper'
import { COMBO, SUBSCRIPTION_DEFINITION_NAMES } from '../constants/subscription'
import { segmentApi } from '@edulastic/api'
import RequestModal from './SubscriptionMain/RequestModals'
import { accessibilityColors } from '@edulastic/colors'

function CartModal({
  products,
  teacherPremium,
  quantities,
  setQuantities,
  setTotalAmount,
  bulkInviteBookKeepers,
  districtId,
  isBookKeepersInviteSuccess,
  setBookKeepersInviteSuccess,
  handleClick,
  visible,
  closeModal,
  handleOpenRequestInvoiceModal,
  subsLicenses,
  itemBankSubscriptions,
  user,
  subType,
  hideCcButton,
  shouldbeMultipleLicenses,
  setIsTabShouldSwitch,
  showDiscountOffer,
  isUserUnverifiedAndLmsUnsynced,
}) {
  const teacherPremiumId = teacherPremium?.id
  const [emailValues, setEmailValues] = useState('')
  const [showSubscriptionsForms, setShowSubscriptionsForms] = useState(false)
  const [subscriptionFormType, setSubscriptionFormType] = useState('request')
  let selectedCombo = {}

  const showSubscriptionFormsModal = (formType = 'request') => {
    setSubscriptionFormType(formType)
    setShowSubscriptionsForms(true)
    const name = subType === 'enterprise' ? 'Enterprise' : 'DS'
    segmentApi.genericEventTrack(`${name}: ${formType}FormButtonClick`, {})
  }

  const setQuantitiesWithLocalStorage = (quantities) => {
    window.localStorage.cartQuantities = quantities
    return setQuantities(quantities)
  }
  useEffect(() => {
    if (isBookKeepersInviteSuccess) {
      const emails = emailValues
        .split(',')
        .map((x) => x.replace(/\s/g, ''))
        .filter((x) => x)

      handleClick({
        emails,
        shouldPayWithCC: true,
      })
    }
    return () => {
      if (isBookKeepersInviteSuccess) {
        setBookKeepersInviteSuccess(false)
      }
    }
  }, [emailValues, isBookKeepersInviteSuccess])

  useEffect(() => {
    const script = document.createElement('script')
    script.src = 'https://js.hsforms.net/forms/v2.js'
    document.body.appendChild(script)
  }, [])

  const handleInputEmailAddress = (ele) => {
    const value = ele.target.value
    setEmailValues(value)
  }

  const handleProceed = () => {
    setIsTabShouldSwitch(false)
    const emails = emailValues
      .split(',')
      .map((x) => x.replace(/\s/g, ''))
      .filter((x) => x)

    for (const email of emails) {
      if (!emailRegex.test(email)) {
        return notification({
          type: 'warn',
          msg: `${email} is invalid email!`,
        })
      }
    }

    bulkInviteBookKeepers({
      districtId,
      userDetails: emails,
    })
  }

  const productsToshow = useMemo(() => {
    return products.filter((x) => {
      if (!x.type.includes(COMBO)) {
        return quantities[x.id]
      } else if (showDiscountOffer && quantities[x.id]) {
        selectedCombo = x
      }
    })
  }, [products, quantities])
  // Find the teacher premium product quantity.
  // If the quantity is greater than 15, show the "Request Quote" button.
  const teacherPremiumQuantity = quantities[teacherPremiumId]
  const showRequestQuoteButton = teacherPremiumQuantity > 15
  if (showRequestQuoteButton) {
    hideCcButton = true
  } else {
    hideCcButton = false
  }
  const footer = [
    hideCcButton ? null : (
      <AuthorCompleteSignupButton
        renderButton={(callback) => (
          <EduButton
            onClick={callback}
            data-cy="proceedPayment"
            width="220px"
            height="45px"
          >
            Pay with Credit Card
          </EduButton>
        )}
        onClick={handleProceed}
      />
    ),
    showRequestQuoteButton ? (
      <EduButton
        data-cy="requestQuote"
        style={{
          margin: '10px 0px',
          outline: `2px solid ${accessibilityColors.theme.white}`,
          outlineOffset: '2px',
        }}
        onClick={() => showSubscriptionFormsModal('request')}
        disabled={isUserUnverifiedAndLmsUnsynced}
        title={
          isUserUnverifiedAndLmsUnsynced
            ? 'Please verify your email to activate.'
            : ''
        }
        height="32px"
        width="180px"
      >
        request a quote
      </EduButton>
    ) : null,
  ]

  const selectedProductIds = Object.keys(quantities).filter(
    (x) => quantities[x]
  )

  const tooltipMessage = 'This user(s) will get manage subscriptions permission'

  return (
    <>
      {showSubscriptionsForms && (
        <RequestModal
          showSubscriptionsForms={showSubscriptionsForms}
          setShowSubscriptionsForms={setShowSubscriptionsForms}
          formType={subscriptionFormType}
        />
      )}
      {!showSubscriptionsForms && (
        <CustomModalStyled
          visible={visible}
          title={`Your ${isPearOrEdulasticText} Cart`}
          modalWidth="510px"
          width="510px"
          destroyOnClose
          footer={footer}
          onCancel={closeModal}
          centered
        >
          <ModalBody>
            {!showDiscountOffer && (
              <p>
                There are additional products that can make instructions easier.
                Subscribe to SparkMath, Spark Reading free trials to see how
                they can help.{' '}
              </p>
            )}
            {showDiscountOffer && (
              <h3 style={{ fontSize: '16px', fontWeight: 600 }}>
                {SUBSCRIPTION_DEFINITION_NAMES[selectedCombo?.type]}
              </h3>
            )}

            <StyledProductsList
              isBuyMore
              isCart
              showRenewalOptions={false}
              showMultiplePurchaseModal={false}
              productsToshow={productsToshow}
              setTotalPurchaseAmount={setTotalAmount}
              setQuantities={setQuantities}
              quantities={quantities}
              setSelectedProductIds={() => {}}
              selectedProductIds={selectedProductIds}
              currentItemId={teacherPremiumId}
              subsLicenses={subsLicenses}
              teacherPremium={teacherPremium}
              itemBankSubscriptions={itemBankSubscriptions}
              user={user}
              subType={subType}
              allProducts={products}
              selectedCombo={selectedCombo}
              showDiscountOffer={showDiscountOffer}
              isRequestingQuote={showRequestQuoteButton}
            />
            {shouldbeMultipleLicenses && !showRequestQuoteButton && (
              <BookkeeperInfoIconWrapper
                tooltipMessage={tooltipMessage}
                emailValues={emailValues}
                handleInputEmailAddress={handleInputEmailAddress}
              />
            )}
            {showRequestQuoteButton && (
              <p style={{ borderTop: '1px solid #dddddd', paddingTop: '12px' }}>
                Customers of 16 or more Teacher Premium licenses receive
                additional support from our team. Please request a quote below.{' '}
              </p>
            )}
          </ModalBody>
        </CustomModalStyled>
      )}
    </>
  )
}

export default connect(
  (state) => ({
    quantities: state?.subscription?.cartQuantities,
    subscription: getSubscriptionSelector(state),
    showDiscountOffer: getShowDiscountOfferSelector(state),
  }),
  {
    setQuantities: subscriptionSlice.actions.setCartQuantities,
  }
)(CartModal)

const StyledProductsList = Styled(ProductsList)`

`
